<template>
  <div class="banner">
    <div class="bannerList" :style="`left:${left}`">
      <div class="bannerItems" :style="`background-image: url('${item}')`" v-for="(item, index) in bannerImg" :key="index"></div>
    </div>
    <div class="bannerControl">
      <div :class="bannerIndex==0?'controlBtn selected':'controlBtn'" @click="changeIndex(0)"></div>
      <div :class="bannerIndex==1?'controlBtn selected':'controlBtn'" @click="changeIndex(1)"></div>
      <div :class="bannerIndex==2?'controlBtn selected':'controlBtn'" @click="changeIndex(2)"></div>      
      <div :class="bannerIndex==3?'controlBtn selected':'controlBtn'" @click="changeIndex(3)"></div>     
      <div :class="bannerIndex==4?'controlBtn selected':'controlBtn'" @click="changeIndex(4)"></div>     
    </div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data() {
    return {
      baseUrl:process.env.BASE_URL, 
      bannerIndex:0,
      cut:1,
      timer:null
    }
  },
  computed:{
    bannerImg(){
      return [
        `${this.baseUrl}img/banner1.jpg`,
        `${this.baseUrl}img/banner2.jpg`,
        `${this.baseUrl}img/banner3.jpg`,
        `${this.baseUrl}img/banner4.jpg`,  
        `${this.baseUrl}img/banner5.jpg`,  
      ]
    },
    left(){
      return (-this.bannerIndex*100)+'vw'
    }
  },
  methods:{
    changeIndex(i){
      this.bannerIndex = i
      clearInterval(this.timer)
      this.timer = setInterval(this.timerFun,4000)
    },
    timerFun(){
      if(this.bannerIndex>=this.bannerImg.length-1){
        this.cut = -1
      }else if(this.bannerIndex==0){
        this.cut = 1
      }
      this.bannerIndex += this.cut
    }
  },
  mounted(){
    this.timer = setInterval(this.timerFun,4000)
  }
}
</script>
<style scoped lang="less">
.banner{
  width: 100vw;
  overflow: hidden;
  position: relative;
  height: 75vh;
  .bannerControl{
    height: 0.3rem;
    display: flex;
    position: absolute;
    left: 50%;
    bottom: 3%;
    transform: translate(-50%,0);
    .controlBtn{
      width: 0.8vw;
      height: 100%;
      margin: 0 0.2rem;
      background-color: #fff;
      border-radius: 0.2rem;
      transition: width 0.2s ease-in-out;
      cursor: pointer;
    }
    .selected{
      background-color: #127ea5;
      width: 2rem;
    }
  }
  .bannerList{
    width: 500%;
    height: 100%;
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    transition: 0.3s ease-in-out all;
    .bannerItems{
        display: block;
        width: 100vw;
        height: 100%;    
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;        
      }
  }
  
}
</style>
